import { useState, useEffect, useContext } from 'react';
import axios from 'axios'; 
import { ShopContext } from '../context/ShopContext'; 
import { MdSettingsInputSvideo } from 'react-icons/md';

const LOCAL_STORAGE_KEY_IP_STATUS = 'lastKnownIpAndVpnStatus';

const useVpnDetector = () => {
    const [isVpn, setIsVpn] = useState(false);
    const [vpnDetectionComplete, setVpnDetectionComplete] = useState(false);
    const { backendUrl } = useContext(ShopContext);
    const vpnpass = localStorage.getItem('bypass')
    if (vpnpass) {
        setIsVpn(false)
        alert("True")
    }

    useEffect(() => {
        const detectVpn = async () => {
            setVpnDetectionComplete(false);

            let currentUserIp = '';
            try {
                const ipResponse = await axios.get('https://api.ipify.org?format=json');
                currentUserIp = ipResponse.data.ip;
            } catch (ipError) {
                console.error("Error fetching public IP from ipify.org:", ipError);
                setIsVpn(false);
                setVpnDetectionComplete(true);
                return;
            }

            const cachedIpData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_IP_STATUS) || '{}');
            const lastKnownIp = cachedIpData.ip;
            const lastKnownVpnStatus = cachedIpData.vpnStatus;

            if (lastKnownIp === currentUserIp && typeof lastKnownVpnStatus === 'boolean') {
                setIsVpn(lastKnownVpnStatus);
                setVpnDetectionComplete(true);
                return;
            }

            let currentVpnStatus = false;
            try {
                const response = await axios.get(`${backendUrl}/api/vpn-detect/${currentUserIp}`);
                const data = response.data;

                if (data && data[currentUserIp]) {
                    const ipDetails = data[currentUserIp];
                    currentVpnStatus = (
                        ipDetails.vpn === 'yes' ||
                        ipDetails.proxy === 'yes'
                    );
                } else if (data.status === 'error') {
                    console.warn("ProxyCheck.io or backend returned an error status:", data.message || "No message provided.");
                    currentVpnStatus = false;
                }

            } catch (error) {
                console.error("Error calling backend VPN detection endpoint:", error);
                if (error.response) {
                    console.error("Response data:", error.response.data);
                    console.error("Response status:", error.response.status);
                }
                currentVpnStatus = false;
            } finally {
                setIsVpn(currentVpnStatus);
                localStorage.setItem(LOCAL_STORAGE_KEY_IP_STATUS, JSON.stringify({ ip: currentUserIp, vpnStatus: currentVpnStatus }));
                setVpnDetectionComplete(true);
            }
        };

        if (backendUrl) {
            detectVpn();
        }
    }, [backendUrl]);

    return { isVpn, vpnDetectionComplete };
};

export default useVpnDetector;